// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"87":"c13fb9b2","314":"364cbc8a","411":"05b30af3","444":"5cadae1f","588":"f704dbce","775":"fef5ddce","872":"d601e67c","933":"282dc2c5","973":"fdcdb426"}[chunkId] + ".css";
};